import "../Routes/dashboardstyles.css"

export default function NotificationPopUp({ notificationsProp }) {
    // Mark all current notifications as read on mount

    return (
        <div className="notification-popup">
            <div className="notification-header">Notifications</div>
            {notificationsProp ? notificationsProp.slice(0).reverse().map((item) => (
                <div className="notification-item"><span style={{ color: 'yellowgreen' }}>{item.coinName}</span>'s current price <span style={{ color: 'yellowgreen' }}>{item.current}$</span> is {item.relation} the defined limit <span style={{ color: 'yellowgreen' }}>{item.limit}$</span></div>
            )) : null}
        </div>
    )
}